'use strict';

var $ = require('jquery');

$(function() {
    $('.detail-card-content').hide();
    $('.detail-card main').hide();


    $('.detail-card-toggle').on('click', function(e){
            //dont want to trigger the header event
            e.stopPropagation();
            $(this).toggleClass('open');
            //header
            $(this).parent().toggleClass('open');
            $(this).find('.detail-card__text-close').toggle();
            $(this).find('.detail-card__text-open').toggle();
            //article
            $(this).parent().parent().toggleClass('open');
            //main
            $(this).next().slideToggle();

            var textbox = $(this);
            if(textbox.attr('aria-expanded') === 'true'){
                textbox.attr('aria-expanded', 'false');
            }else{
                textbox.attr('aria-expanded', 'true');
            }
        });

    $('.detail-card header').on('click', function(e){
        //this event for opening the detail box by clicking the header
        $(this).addClass('open');
        $(this).parent().find('label').addClass('open');
        $(this).parent().find('article').addClass('open');
        $(this).parent().find('.content').slideDown();
        $(this).parent().find('.detail-card__text-close').show();
        $(this).parent().find('.detail-card__text-open').hide();

        var textbox = $(this).parent().find('main');
        textbox.attr('aria-expanded', 'true');
    });

    

    $('.detail-card__text-close').hide();

});
